module.exports = __webpack_public_path__ + "static/media/honestidad.6740c010.svg";